import React, {
  useContext, useMemo, FunctionComponent,
} from 'react';
import {
  ICON_CLOSE, ICON_MAGNIFY, Input, InputProps,
} from '@doveit/lego';
import FilterableListContext from '../AsyncSuggestionListContext';

import * as styles from './SearchInput.style';

export type SearchInputProps = Partial<InputProps>;

const SearchInput: FunctionComponent<SearchInputProps> = ({
  label,
  placeholder,
  ...rest
}) => {
  const {
    searchTerm,
    onInputChange,
  } = useContext(FilterableListContext);

  const hasSearchTerm = useMemo(
    () => searchTerm && searchTerm.length > 0,
    [searchTerm],
  );

  const onClickIcon = useMemo(
    () => (hasSearchTerm
      ? () => onInputChange('')
      : undefined),
    [onInputChange, hasSearchTerm],
  );

  return (
    <>
      {
        label && (
          <label
            css={styles.label}
            htmlFor="filterInput"
          >
            {label}
          </label>
        )
      }
      <Input
        {...rest}
        id="filterInput"
        aria-label={label}
        icon={hasSearchTerm ? ICON_CLOSE : ICON_MAGNIFY}
        onClickIcon={onClickIcon}
        value={searchTerm || ''}
        placeholder={placeholder}
        onChange={({ target }) => onInputChange(target.value)}
      />
    </>
  );
};

export default SearchInput;
